module.exports = __webpack_public_path__ + "1ff14aaf21a75881c1c13376f387ad2a.ttf";